<template>
  <div class="conditions">
    <w-loader v-show="isLoading"></w-loader>
    <div v-show="!isLoading">
      <div class="container-fluid">
        <div class="row padding-0">
          <div class="col-xs-12 font-size-l text-align-l padding-0">
            <span class="padding-10 display-b text-align-c conditions-title">Current Conditions</span>
          </div>
        </div>
      </div>
      <!-- TODO: tabs -->
      
      <div class="container">
        <div class="row">
          <div class="col-xs-12">
            <div class="parent">
              <div v-bind:style="{width: (100 / multipleConditions.snowReport.length) - 1 + '%' }" class="list-item" v-show="multipleConditions.snowReport.length > 1" v-for="(item, index) in multipleConditions.snowReport" :key="index">
                <div class="padding-4 display-b border-1 border-solid border-color-b-010 margin-0-auto border-radius-4 width-0100 margin-t-10 margin-b-10 text-align-c" v-bind:class="[{'bg-color-b-080': visibility[index]}, visibility[index] ? 'color-w-0100 selected' : 'color-b-080']" @click="toggleView(index)">
                  <span>{{ item.measurement_location_name }}</span>
                </div>
              </div>
            </div>
            <div v-for="(item, index) in multipleConditions.snowReport" :key="item.measurement_location_name" v-show="visibility[index]">
              <!-- <span v-show="multipleConditions.snowReport.length > 1" class="padding-10 display-b text-align-c conditions-title">{{ item.measurement_location_name }}</span> -->
              <Place :conditions="item" class="padding-b-50"/>
            </div>
            <span class="padding-10 display-b text-align-c conditions-title">Snow Surface</span>
            <div v-show="mountainOverview.secondary_surface_density">
              <!-- shows with both surface densities -->
            <div class="width-0100 display-t border-b-1 border-solid border-color-b-010">
              <div class="display-tc width-050 vertical-align-b padding-r-5 border-r-1 border-solid border-color-b-010" v-show="mountainOverview.main_surface_density">
                <p class="font-size-s color-b-030 font-weight-bi width-070 font-style-i">Main Surface</p>
                <p class="display-b color-b-0100 font-size-m text-align-r margin-t-20 margin-b-16">{{ mountainOverview.main_surface_density }}</p>
              </div>
              <div class="display-tc width-050 vertical-align-t position-r padding-l-5" v-show="mountainOverview.secondary_surface_density">
                  <p class="font-size-s color-b-030 font-weight-bi width-070 font-style-i">Secondary Surface</p>
                  <p class="display-b color-b-0100 font-size-m text-align-r margin-t-20 margin-b-16">{{ mountainOverview.secondary_surface_density }}</p>
              </div>
            </div>
            </div>
            <div v-show="!mountainOverview.secondary_surface_density">
              <!-- shows with only main surface density -->
              <div class="width-0100 display-t border-b-1 border-solid border-color-b-010">
                <div class="display-tc width-050 vertical-align-b padding-r-5 border-solid border-color-b-010" v-show="mountainOverview.main_surface_density">
                  <p class="font-size-s color-b-030 font-weight-bi width-070 font-style-i">Surface</p>
                  <p class="display-b color-b-0100 font-size-m text-align-r margin-t-20 margin-b-16">{{ mountainOverview.main_surface_density }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="container-fluid margin-t-20" v-show="mountainOverview.report">
        <div class="row padding-0">
          <div class="col-xs-12 font-size-l text-align-l padding-0">
            <span class="padding-10 display-b text-align-c conditions-title">The Report</span>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-xs-12">
            <div class="padding-t-20 padding-b-20 clearfix font-size-m line-h-24 report">
              <p v-html="mountainOverview.report"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // Import components
  import WLoader from '@/components/shared/Loader.vue'

  // Import services
  import widgetService from '@/services/widget-service'

  // Import libraries
  import _ from 'lodash'

  // Import component
  import Place from './Place'

  export default {
    data () {
      return {
        isLoading: true,
        multipleConditions: [],
        visibility: [],
        mountainOverview: {
          main_surface_density: '',
          secondary_surface_density: '',
          report: ''
        }
      }
    },
    components: {
      WLoader,
      Place
    },
    mounted () {
      this.refresh()
    },
    methods: {
      addListItem() {
        this.multipleConditions.snowReport.forEach((val, idx) => {
          if (idx === 0) {
            this.visibility.push(true)
          } else {
            this.visibility.push(false)
          }
        })
      },
      toggleView(index) {
        this.visibility.forEach((element, idx) => {
          if (idx === index) {
            this.visibility[idx] = true
          } else {
            this.visibility[idx] = false
          }
        });
        console.log(this.visibility)
        this.refresh()
      },
      refresh () {
        widgetService.getConditions(this.$route.query.json)
          .then((conditionsData) => {
            this.multipleConditions = conditionsData
            this.mountainOverview = {
              main_surface_density: _.has(conditionsData.mountainOverview, 'density.main_snow_surface.0.density') ? conditionsData.mountainOverview.density.main_snow_surface[0].density : '-',
              secondary_surface_density: _.has(conditionsData.mountainOverview, 'density.off_snow_surface.0.density') ? conditionsData.mountainOverview.density.off_snow_surface[0].density : '',
              report: _.has(conditionsData.mountainOverview, 'groups[0].updates[0].html') ? conditionsData.mountainOverview.groups[0].updates[0].html : ''
            }

            if(!_.has(conditionsData.mountainOverview, 'groups[0].updates[0].html')){
              this.mountainOverview.report = '';
            }
            else{
              try {
                this.mountainOverview.report = conditionsData.mountainOverview.groups[0].updates[0].html.replace(/\/\//g, '<br><br>').replace(/http\:<br><br>/g, 'http://').replace(/https\:<br><br>/g, 'https://')
              } catch (e) {
                this.mountainOverview.report = conditionsData.mountainOverview.groups[0].updates[0].html;
              }
            }

            if (this.isLoading) {
              this.addListItem()
              this.isLoading = false
            }
            console.log(this.multipleConditions.snowReport.length)
          })
      }
    }
  }
</script>

<style lang="scss">
  @import url(https://fonts.googleapis.com/css?family=Anton|Lora);

  .conditions {
    font-family: 'Lora', serif;
    max-height: 100vh;
    overflow: auto;
  }
  
  .conditions-title {
    font-family: 'Anton', serif;
  }

  .report {
    margin-bottom: 60px;
  }

  .list-item {
    display: inline-block;
    padding: 5px;
    padding-bottom: 10px;
  }

  .parent {
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/ConditionsMulti/ConditionsMulti.vue